import { render, staticRenderFns } from "./ConsumivelTabList.vue?vue&type=template&id=03ae3afc&scoped=true"
import script from "./ConsumivelTabList.vue?vue&type=script&lang=js"
export * from "./ConsumivelTabList.vue?vue&type=script&lang=js"
import style0 from "./ConsumivelTabList.vue?vue&type=style&index=0&id=03ae3afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae3afc",
  null
  
)

export default component.exports